import React from 'react';
import { LayoutGrid, RefreshCw, ChevronDown, Info } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Card } from '../components/ui/Card';
import { ModelsPanel } from '../components/energy/ModelsPanel';
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
const chartData = Array.from({
  length: 24
}, (_, i) => ({
  hour: i,
  value1: 4 + Math.random() * 4,
  value2: 4 + Math.random() * 4
}));
export function EnergyMarketView() {
  return <div className="jua-page-bg h-[calc(100vh-64px)] w-full flex flex-col p-4 gap-4 overflow-hidden" data-id="element-2215">
      {/* Header & Filters */}
      <div className="flex flex-col gap-4" data-id="element-2216">
        <div className="flex items-center gap-2" data-id="element-2217">
          <div className="h-2 w-2 rounded-full bg-[#EC4899]" data-id="element-2218" />
          <h1 className="text-lg font-bold text-white" data-id="element-2219">Dashboard</h1>
        </div>

        <div className="flex flex-wrap items-center gap-3 text-sm" data-id="element-2220">
          <div className="flex items-center gap-2 bg-slate-800/50 p-1 rounded-lg border border-slate-700/50" data-id="element-2221">
            <span className="px-2 text-slate-500 text-xs uppercase font-bold" data-id="element-2222">
              Variable
            </span>
            <Button size="sm" className="h-6 bg-slate-700 text-white hover:bg-slate-600" data-id="element-2223">
              Wind
            </Button>
            <Button size="sm" variant="ghost" className="h-6" data-id="element-2224">
              Solar
            </Button>
            <Button size="sm" variant="ghost" className="h-6" data-id="element-2225">
              Temperature
            </Button>
          </div>

          <div className="flex items-center gap-2 bg-slate-800/50 p-1 rounded-lg border border-slate-700/50" data-id="element-2226">
            <span className="px-2 text-slate-500 text-xs uppercase font-bold" data-id="element-2227">
              Horizon
            </span>
            <Button size="sm" variant="ghost" className="h-6" data-id="element-2228">
              2d
            </Button>
            <Button size="sm" className="h-6 bg-slate-700 text-white hover:bg-slate-600" data-id="element-2229">
              5d
            </Button>
            <Button size="sm" variant="ghost" className="h-6" data-id="element-2230">
              10d
            </Button>
          </div>

          <Button size="sm" variant="outline" className="h-8 gap-2 border-slate-700 bg-slate-800/50" data-id="element-2231">
            Germany <ChevronDown size={14} data-id="element-2232" />
          </Button>

          <Badge variant="outline" className="h-8 px-3 bg-slate-800/50" data-id="element-2233">
            Zurich - Central European Time (CET)
          </Badge>

          <div className="ml-auto flex items-center gap-2" data-id="element-2234">
            <Button size="sm" variant="outline" className="h-8 gap-2 border-slate-700 bg-slate-800/50" data-id="element-2235">
              <LayoutGrid size={14} data-id="element-2236" /> Cards (4)
            </Button>
            <Button size="sm" variant="outline" className="h-8 gap-2 border-slate-700 bg-slate-800/50" data-id="element-2237">
              <RefreshCw size={14} data-id="element-2238" /> Reset Layout
            </Button>
          </div>
        </div>
      </div>

      {/* Grid Layout */}
      <div className="flex-1 grid grid-cols-12 grid-rows-2 gap-4 min-h-0" data-id="element-2239">
        {/* Top Left: Models */}
        <div className="col-span-3 row-span-1" data-id="element-2240">
          <ModelsPanel data-id="element-2241" />
        </div>

        {/* Top Right: Forecast Chart */}
        <Card className="col-span-9 row-span-1 p-4 flex flex-col border-slate-700/50" data-id="element-2242">
          <div className="flex items-center justify-between mb-4" data-id="element-2243">
            <div className="flex items-center gap-2" data-id="element-2244">
              <h3 className="font-semibold text-slate-200" data-id="element-2245">
                Forecast Chart - Germany
              </h3>
              <Info size={14} className="text-slate-500" data-id="element-2246" />
            </div>
            <div className="flex items-center gap-2" data-id="element-2247">
              <Badge variant="outline" className="bg-slate-800" data-id="element-2248">
                Data
              </Badge>
              <Badge variant="outline" className="bg-transparent border-transparent text-slate-400" data-id="element-2249">
                Δ Delta
              </Badge>
            </div>
          </div>
          <div className="flex-1 min-h-0" data-id="element-2250">
            <ResponsiveContainer width="100%" height="100%" data-id="element-2251">
              <LineChart data={chartData} data-id="element-2252">
                <CartesianGrid strokeDasharray="3 3" stroke="#1e293b" vertical={false} data-id="element-2253" />
                <XAxis dataKey="hour" hide data-id="element-2254" />
                <YAxis stroke="#64748b" fontSize={10} axisLine={false} tickLine={false} data-id="element-2255" />
                <Tooltip contentStyle={{
                backgroundColor: '#1e293b',
                borderColor: '#334155'
              }} data-id="element-2256" />
                <Line type="monotone" dataKey="value1" stroke="#EC4899" strokeWidth={2} dot={false} data-id="element-2257" />
                <Line type="monotone" dataKey="value2" stroke="#3b82f6" strokeWidth={2} strokeDasharray="5 5" dot={false} data-id="element-2258" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Card>

        {/* Bottom Left: Map (Placeholder for Heatmap) */}
        <Card className="col-span-4 row-span-1 border-slate-700/50 relative overflow-hidden group" data-id="element-2259">
          <div className="absolute inset-0 bg-[#0B1120]" data-id="element-2260">
            {/* Simple map placeholder visual */}
            <div className="w-full h-full opacity-30 bg-[url('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/4/5/8')]" data-id="element-2261" />
            {/* Germany Highlight */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-32 border-2 border-[#EC4899] bg-[#EC4899]/20 rounded-full blur-xl" data-id="element-2262" />
          </div>
          <div className="absolute top-3 left-3 z-10 flex items-center gap-2" data-id="element-2263">
            <span className="text-sm font-semibold text-white" data-id="element-2264">
              Market Zones
            </span>
            <span className="text-xs text-[#EC4899]" data-id="element-2265">1 selected: Germany</span>
          </div>
        </Card>

        {/* Bottom Right: Heatmap Table */}
        <Card className="col-span-8 row-span-1 p-4 border-slate-700/50 flex flex-col" data-id="element-2266">
          <div className="flex items-center justify-between mb-4 border-b border-slate-800 pb-2" data-id="element-2267">
            <div className="flex items-center gap-6" data-id="element-2268">
              <h3 className="font-semibold text-slate-200" data-id="element-2269">Heatmap</h3>
              <div className="flex gap-4 text-sm" data-id="element-2270">
                <span className="text-[#EC4899] border-b-2 border-[#EC4899] pb-2 -mb-2.5" data-id="element-2271">
                  Heatmap Deviations
                </span>
                <span className="text-slate-500" data-id="element-2272">Heatmap Disagreements</span>
              </div>
            </div>
            <div className="flex gap-2" data-id="element-2273">
              <Button size="sm" variant="ghost" className="h-7 text-xs" data-id="element-2274">
                Hourly
              </Button>
              <Button size="sm" className="h-7 text-xs bg-slate-700 text-white" data-id="element-2275">
                Daily
              </Button>
            </div>
          </div>

          <div className="flex-1 overflow-auto" data-id="element-2276">
            <table className="w-full text-xs" data-id="element-2277">
              <thead data-id="element-2278">
                <tr className="text-slate-500" data-id="element-2279">
                  <th className="text-left py-2" data-id="element-2280">Models</th>
                  <th data-id="element-2281">Feb 11</th>
                  <th data-id="element-2282">Feb 12</th>
                  <th data-id="element-2283">Feb 13</th>
                  <th data-id="element-2284">Feb 14</th>
                  <th data-id="element-2285">Feb 15</th>
                </tr>
              </thead>
              <tbody className="text-center" data-id="element-2286">
                <tr className="border-b border-slate-800/50" data-id="element-2287">
                  <td className="text-left py-3 font-medium text-slate-300" data-id="element-2288">
                    EPT-2
                    <br data-id="element-2289" />
                    <span className="text-slate-500 font-normal" data-id="element-2290">
                      2026-02-11 06:00
                    </span>
                  </td>
                  <td data-id="element-2291">
                    <span className="bg-blue-600/20 text-blue-400 px-2 py-1 rounded" data-id="element-2292">
                      -0.2
                    </span>
                  </td>
                  <td data-id="element-2293">
                    <span className="bg-pink-600/20 text-pink-400 px-2 py-1 rounded" data-id="element-2294">
                      +0.1
                    </span>
                  </td>
                  <td data-id="element-2295">
                    <span className="bg-blue-600/20 text-blue-400 px-2 py-1 rounded" data-id="element-2296">
                      -0.4
                    </span>
                  </td>
                  <td data-id="element-2297">
                    <span className="bg-slate-800 text-slate-400 px-2 py-1 rounded" data-id="element-2298">
                      -0.0
                    </span>
                  </td>
                  <td data-id="element-2299">
                    <span className="bg-pink-600/20 text-pink-400 px-2 py-1 rounded" data-id="element-2300">
                      +0.0
                    </span>
                  </td>
                </tr>
                <tr data-id="element-2301">
                  <td className="text-left py-3 font-medium text-slate-300" data-id="element-2302">
                    EC IFS
                    <br data-id="element-2303" />
                    <span className="text-slate-500 font-normal" data-id="element-2304">
                      2026-02-11 06:00
                    </span>
                  </td>
                  <td data-id="element-2305">
                    <span className="bg-pink-600/20 text-pink-400 px-2 py-1 rounded" data-id="element-2306">
                      +0.2
                    </span>
                  </td>
                  <td data-id="element-2307">
                    <span className="bg-blue-600/20 text-blue-400 px-2 py-1 rounded" data-id="element-2308">
                      -0.1
                    </span>
                  </td>
                  <td data-id="element-2309">
                    <span className="bg-pink-600/20 text-pink-400 px-2 py-1 rounded" data-id="element-2310">
                      +0.4
                    </span>
                  </td>
                  <td data-id="element-2311">
                    <span className="bg-pink-600/20 text-pink-400 px-2 py-1 rounded" data-id="element-2312">
                      +0.0
                    </span>
                  </td>
                  <td data-id="element-2313">
                    <span className="bg-blue-600/20 text-blue-400 px-2 py-1 rounded" data-id="element-2314">
                      -0.0
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </div>;
}